<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-row>
          <b-col md="6" class="my-1">
            <b-navbar-nav>
              <b-button @click="goBack" size="sm" variant="outline-secondary">
                <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
              </b-button>
            </b-navbar-nav>
            <h5 class="mt-1 mr-2">
              {{ $route.name }}
            </h5>
          </b-col>
          <b-col md="2">
            <h5>
              <small v-if="isLoading == false">{{ totalData }} Entries</small>
            </h5>
          </b-col>
          <b-col md="4">
            <b-button class="pull-right ml-1 mt-1" :variant="Filter.job_no ||
              Filter.isEmailSendStatus ||
              Filter.email_type ||
              Filter.createdByFilter ||
              Filter.dateRange.startDate ||
              Filter.dateRange.endDate
              ? 'outline-danger'
              : 'outline-primary'
              " :class="' ml-4' + visible ? null : 'collapsed'" :aria-expanded="visible ? 'true' : 'false'"
              aria-controls="collapse-4" @click="visible = !visible" style="font-size: 0.675rem">{{
                Filter.job_no ||
                  Filter.isEmailSendStatus ||
                  Filter.email_type ||
                  Filter.createdByFilter ||
                  Filter.dateRange.startDate ||
                  Filter.dateRange.endDate
                  ? "Filter ON"
                  : "Filter OFF"
              }}</b-button>
            <b-button class="pull-right ml-1 mt-1" v-if="getEmailLogList.length > 0"
              :disabled="ExcelBtnName != 'Export As Excel' ? true : false"
              @click="getReports('getEmailLogList', 'Export As Excel')" size="sm" variant="warning"
              style="font-size: 0.675rem">
              {{ ExcelBtnName }}
              <b-spinner v-if="ExcelBtnName != 'Export As Excel'" small label="Small Spinner"></b-spinner></b-button>
          </b-col>

          <b-col cols="12">
            <div>
              <b-pagination limit="50" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </b-col>
        </b-row>
        <div v-if="visible">
          <b-card>
            <b-collapse v-model="visible" id="collapse-2">
              <b-row>
                <b-col md="3">
                  <label>Status</label>

                  <model-list-select :list="StatusList" v-model="Filter.isEmailSendStatus" option-value="DVal"
                    option-text="DText" placeholder="Select"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"></model-list-select>
                </b-col>
               
                <b-col md="3">
                  <label>Date</label>
                  <date-range-picker :always-show-calendars="showCal" v-model="Filter.dateRange" :startDate="startDate"
                    :endDate="endDate" :locale-data="locale" :disabled="Filter.DFlag ? true : false"
                    @update="getEmailLogTempList('Normal', '0', '0', '1', '1')"></date-range-picker>
                </b-col>

                <b-col md="3">
                  <label>Job No Filter</label>
                  <b-form-input type="text" :formatter="capitalizeAll" placeholder="Search Job No Filter" id="job_no"
                    name="job_no" autocomplete="off" v-model="Filter.job_no"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')"></b-form-input>
                </b-col>
                <b-col md="3">
                  <label>
                    <b> Created User </b>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllUserList']" id="createdByFilter"
                    @input="getEmailLogTempList('Normal', '0', '0', '1', '1')" v-model="Filter.createdByFilter"
                    option-value="userId" option-text="employeeName"
                    placeholder="Select Created User"></model-list-select>
                </b-col>
                <b-col md="12" class="mt-2">
                  <b-button size="sm" style="margin-left: auto" class="ml-1 pull-right" @click="clearFilter"
                    variant="outline-danger">Reset</b-button>
                </b-col>
              </b-row>
            </b-collapse>
          </b-card>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="table-responsive tableMain gutr">
              <b-table show-empty stacked="md" responsive :items="getEmailLogList" :fields="emailLogFields"
                primary-key="id_email_section" :per-page="pagination.perPage" :filter="filter" :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered"
                class="position-relative">
                <template slot="SN" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (pagination.currentPage - 1) * pagination.perPage
                  }}</span>
                </template>
                <template slot="ClientName" slot-scope="row3">
                    <span v-if="row3.item.ClientName">Client : {{ row3.item.ClientName }}<br /></span>
                    <span v-if="row3.item.SlineName">Sline : {{ row3.item.SlineName }}<br /></span>
                  </template>
                <template slot="isEmailSendStatus" slot-scope="row1">
                  <b-badge :variant="row1.item.is_email_send == 0 ? 'danger' : 'success'">{{
                    row1.item.isEmailSendStatus
                  }}</b-badge>
                </template>
                <template slot="ExpCreatedByEmail" slot-scope="row5">
                  <div class="text-left" v-if="row5.item.ExpCreatedByEmail">
                    <div v-if="row5.item.ExpCreatedByEmail">
                      <span v-for="(item1, index) in row5.item.ExpCreatedByEmail.split(',')" :key="index">
                        <h6>
                          <b-badge variant="light">{{ item1 == "" ? "-------" : item1 }}
                          </b-badge>
                        </h6>
                      </span>
                    </div>
                  </div>
                </template>

                <template slot="ExpCreatedBy" slot-scope="row3">
                  <span v-if="row3.item.ExpCreatedBy">Raised By : {{ row3.item.ExpCreatedBy }}<br /></span>
                  <span v-if="row3.item.ExpCreatedDate">Created Date : {{ row3.item.ExpCreatedDate }}<br /></span>

                  <b-button size="sm" class="ml-2" @click="ViewEmail(row3.item)" variant="primary">View EMail</b-button>
                  <!-- <b-button v-if="row3.item.is_email_send == 0" size="sm" class="ml-2" @click="sendEmail(row3.item)"
                    variant="primary">Send</b-button> -->
                </template>
              </b-table>
            </div>

            <div>
              <b-pagination limit="50" align="center" v-model="pagination.currentPage" :per-page="pagination.perPage"
                :total-rows="totalData" @change="onPageChange($event)"></b-pagination>
            </div>
          </div>
        </div>
      </b-card-text>
    </b-card>
    <!-- Additional Extra Payment Modal Start -->
    <b-modal id="modal-email-log" ref="modal-email-log" :title="Email_JobNo" size="lg" centered no-close-on-esc
      no-close-on-backdrop hide-footer>
      <h3 v-if="Email_log_body.isEmailSendStatus">{{ Email_log_body.isEmailSendStatus }}</h3>
      <template>
        <div class="email-container">
          <p>Hi Team Accounts,</p>
          <p>
            Additional Task Payment Request has been issued for assignment No. :
            <strong>{{ Email_log_body.JobNo }}</strong>
          </p>
          <table border="1" cellpadding="5" cellspacing="0" style="border-collapse: collapse; width: 100%;">
            <tr>
              <th>Assignment No</th>
              <td>{{ Email_log_body.JobNo }}</td>
            </tr>
            <tr>
              <th>Assignment Date</th>
              <td>{{ Email_log_body.JobCreatedDate }}</td>
            </tr>
            <tr>
              <th>Raised From</th>
              <td>{{ Email_log_body.RaisedFrom }}</td>
            </tr>
            <tr>
              <th>Raised By</th>
              <td>{{ Email_log_body.RaisedBy }}</td>
            </tr>
            <tr>
              <th>Client Name</th>
              <td>{{ Email_log_body.ClientName }}</td>
            </tr>
            <tr>
              <th>Shipping Line</th>
              <td>{{ Email_log_body.SlineName }}</td>
            </tr>
            <tr>
              <th>Handover</th>
              <td>{{ Email_log_body.HAND }}</td>
            </tr>
            <tr>
              <th>Stuffing</th>
              <td>{{ Email_log_body.STUFF }}</td>
            </tr>
            <tr>
              <th>Pickup</th>
              <td>{{ Email_log_body.PICK }}</td>
            </tr>
            <tr>
              <th>Container Type</th>
              <td>{{ Email_log_body.containerType }}</td>
            </tr>
            <tr>
              <th>POR</th>
              <td>{{ Email_log_body.POR }}</td>
            </tr>
            <tr>
              <th>POL</th>
              <td>{{ Email_log_body.POL }}</td>
            </tr>
            <tr>
              <th>POD</th>
              <td>{{ Email_log_body.POD }}</td>
            </tr>
            <tr>
              <th>FPOD</th>
              <td>{{ Email_log_body.FPOD }}</td>
            </tr>
            <tr>
              <th>Remark</th>
              <td>{{ Email_log_body.docRemarks }}</td>
            </tr>
            <tr>
              <th>Payment Request Date</th>
              <td>{{ Email_log_body.ExpCreatedDate }}</td>
            </tr>
            <tr>
              <th>Payment Request Issued By</th>
              <td>{{ Email_log_body.ExpCreatedBy }}</td>
            </tr>
          </table>
          <p>Thanks,</p>
          <p><strong>TEAM PRANALI</strong></p>
        </div>
      </template>


      <b-button @click="closeEmailLog" variant="danger" class="pull-right">
        Close</b-button>
    </b-modal>
    <!-- Additional Extra Payment Modal End -->
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import CustomLoader from "../common/customLoader.vue";
import { DateFormat, selectDateFormat } from "../../helper/filters.js";
import { lastVisitPage, globalPermissionStatus } from "../../helper/collection.js";
import DateRangePicker from "vue2-daterange-picker";
import CommonService from "../../services/CommonService.js";
import { ModelListSelect, MultiSelect } from "vue-search-select";
import Multiselect from "vue-multiselect";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import NodeLockPannelService from "../../services/NodeLockPannelService.js";
export default {
  // Component logic for Tab 1
  beforeMount() {
    lastVisitPage(this.$router.history.current.fullPath);
    this.getCurrentLastDate();
    this.$store.dispatch(
      "common/setAllUserList",
      JSON.stringify({
        itemCode: "GET_USERLIST_Data",
      })
    );
    this.$store.dispatch("setCurrentRoute", "/log/email-log");
    if (this.lastVisitPage && this.$sessionsStorage.get("lastVisitPage")) {
      this.fetchLastPage(this.lastVisitPage);
    } else {
      this.getEmailLogTempList("Normal", "0", "0", "1", "1");
    }
  },
  mounted() { },
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() { },

  destroyed() { },
  data() {
    return {
      Email_isEmailSendStatus: "",
      Email_JobNo: "",
      Email_log_body: "",
      docURL: URL_BASE_DOC,
      selectDateFormat,
      lastVisitPage: this.$sessionsStorage.get("lastVisitPage"),
      ExcelBtnName: "Export As Excel",
      visible: false,
      getEmailLogList: [],
      totalData: 0,
      emailLogFields: [
        {
          key: "SN",
          mainkey: "SN",
          label: "SN.",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        {
          key: "JobNo",
          mainkey: "JobNo",
          label: "Job No",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ledgermaster_all_expenses_relation.ledger",
          mainkey: "ledgermaster_all_expenses_relation.ledger",
          label: "Particulars",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "selling_amt",
          mainkey: "selling_amt",
          label: "AMT",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "scCategory",
          mainkey: "scCategory",
          label: "Category",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "remark",
          mainkey: "remark",
          label: "Remark",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ClientName",
          mainkey: "ClientName",
          label: "Clinet/Sline",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "isEmailSendStatus",
          mainkey: "isEmailSendStatus",
          label: "Status",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "Subject",
          mainkey: "Subject",
          label: "Subject",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ExpCreatedByEmail",
          mainkey: "ExpCreatedByEmail",
          label: "To Email",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },

        {
          key: "isEmailSendStatus",
          mainkey: "isEmailSendStatus",
          label: "Send Status",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
        {
          key: "ExpCreatedBy",
          mainkey: "ExpCreatedBy",
          label: "Action",
          sortable: true,
          sortDirection: "ASC",
          table: "C.",
        },
      ],

      pagination: {
        currentPage: 1,
        perPage: 50,
        pageOptions: [5, 10, 15],
      },
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,

      StatusList: [
        {
          DVal: "0",
          DText: "Failed",
        },
        {
          DVal: "1",
          DText: "Success",
        },
        {
          DVal: "2",
          DText: "All",
        },
      ],
      StatusTypeList: [
        {
          DVal: "Multiple Expense",
          DText: "Multiple Expense",
        },
        {
          DVal: "Additional Task",
          DText: "Additional Task",
        },
        {
          DVal: "",
          DText: "All",
        },
      ],

      Filter: {
        job_no: "",
        email_type: "",
        clientFilter: "",
        createdByFilter: "",
        isEmailSendStatus: "0",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      },
      openLeft: "left",
      showCal: false,
      startDate: "2017-09-05",
      endDate: "2017-09-15",
      dateRange: {
        startDate: "",
        endDate: "",
      },
      locale: {
        direction: "ltr",
        format: "mm/dd/yyyy",
        separator: " - ",
        applyLabel: "Apply",
        cancelLabel: "Cancel",
        weekLabel: "W",
        customRangeLabel: "Custom Range",
        daysOfWeek: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        monthNames: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec",
        ],
        firstDay: 0,
      },
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      value1: [new Date(2019, 9, 8), new Date(2019, 9, 19)],
      value2: [],
      langType: {
        pickers: ["Today", "Yesterday", "This Month", "This Year"],
      },
      time: "",
      date: "",
      week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],

      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      isLoading: false,
    };
  },

  components: {
    CustomLoader,
    DatePicker,
    ModelListSelect,
    DateRangePicker,

    MultiSelect,
    Multiselect,
  },
  computed: {},

  methods: {
    clearFilter() {
      this.Filter = {
        job_no: "",
        isEmailSendStatus: "",
        email_type: "",
        createdByFilter: "",
        isEmailSendStatus: "2",
        dateRange: {
          startDate: "",
          endDate: "",
        },
        startDate: "",
        endDate: "",
      };
    },
    getCurrentLastDate() {
      var today = new Date();
      var firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      var lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      var firstDay_dd = String(firstDay.getDate()).padStart(2, "0");
      var firstDay_mm = String(firstDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var firstDay_yyyy = firstDay.getFullYear();

      var lastDay_dd = String(lastDay.getDate()).padStart(2, "0");
      var lastDay_mm = String(lastDay.getMonth() + 1).padStart(2, "0"); //January is 0!
      var lastDay_yyyy = lastDay.getFullYear();

      firstDay = firstDay_yyyy + "/" + firstDay_mm + "/" + firstDay_dd; //2018-06-01
      lastDay = lastDay_yyyy + "/" + lastDay_mm + "/" + lastDay_dd; //2018-06-01

      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      today = yyyy + "/" + mm + "/" + dd; //2018-06-01
      this.startDate = today;
      this.Filter.dateRange = {
        startDate: firstDay,
        endDate: lastDay,
      };
    },

    ViewEmail(item) {
      console.log(item);
      this.Email_isEmailSendStatus = item.isEmailSendStatus;
      this.Email_JobNo = item.JobNo;
      this.Email_log_body = item;

      this.$refs["modal-email-log"].show();
    },
    closeEmailLog() {
      this.Email_isEmailSendStatus = "";
      this.Email_JobNo = "";
      this.Email_log_body = "";
      this.$refs["modal-email-log"].hide();
    },
    PrintValidity_Doc(item, job_no) {
      window.open(
        item
      );
    },
    
    sendEmail(item) {
      let payload = {};
      if (item.doc_id > 0) {
        this.isLoading = true;
        payload = {
          itemCode: "sendEmailLog",
          allModuleId: item.allModuleId,
          doc_id: item.doc_id,
        };

        NodeLockPannelService.getFailedAdditionalTask(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              this.alert.content = data.message;
              this.$refs["addPop"].open();
              this.getEmailLogTempList("Normal", "0", "0", "1", "1");
            }
            this.isLoading = false;
          })
          .catch((error) => {
            console.log("Catch on sendEmailLog Error: ", error);
          });
      }
    },
    getEmailLogTempList(type, filterIdD, CURRENT, SEARCH, pageNumber) {
      this.getEmailLogList = [];
      let payload = {};
      if (type == "Normal") {
        this.isLoading = true;
      }
      payload = {
        itemCode: "getEmailLogList",
        type: type,
        DCfilterId: filterIdD,
        searchVal: this.filter,
        DCfilterId: filterIdD,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.pagination.perPage,
        Filter: this.Filter,
      };

      NodeLockPannelService.getFailedAdditionalTask(payload)
        .then((response) => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excell") {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalExpenseList;
                this.getEmailLogList = data.data;
              }
              this.ExcelBtnName = "Export As Excel";
              window.location.href =
                `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.data.length > 0) {
                this.totalData = data.pagination.totalExpenseList;
                this.getEmailLogList = data.data;
              }
            }
          }
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("Catch on getEmailLogList Error: ", error);
        });
    },
    onFiltered(filtered) {
      this.totalRows = filtered.length;
      this.pagination.currentPage = 1;
    },
    clearTimeout() { },
    goBack() {
      window.history.go(-1);
    },

    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getEmailLogTempList("Normal", "0", "0", "1", "1");
      }, 1000);
    },
    getReports(id, btnName) {
      this.isLoading = true;
      this.ExcelBtnName = "Downloading Please Wait .....";
      this.getEmailLogTempList("Excell", "0", "0", "1", "1");
    },
    fetchLastPage(event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = parseInt(event) * this.pagination.perPage - this.pagination.perPage;
      }
      this.getEmailLogTempList("Normal", "0", CURRENT, "2", event);
    },
    onPageChange: function (event) {
      this.$sessionsStorage.set("lastVisitPage", event);
      this.$sessionsStorage.set("oldRoute", this.$router.history.current.fullPath);
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.pagination.perPage - this.pagination.perPage;
      }
      this.getEmailLogTempList("Normal", "0", CURRENT, "2", event);
    },
  },
};
</script>



// WEBPACK FOOTER //
// FailedAdditionalTaskList.vue?7a96a0b2